import React, { useEffect } from 'react';
import { useLocation, useNavigate, Navigate } from 'react-router-dom';
import api from '../services/api';

let AuthContext = React.createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = React.useState();
  const [perms, setPerm] = React.useState([]);
  const [name, setName] = React.useState();
  const [loading, setLoading] = React.useState(true);
  const [logout, setLogout] = React.useState(false); // Mantendo a variável original
  const navigate = useNavigate();
  
  React.useEffect(() => {
    const initAuth = async () => {
      setLoading(true);
      if (validateToken()) {
        try {
          await getUser();
        } catch (error) {
          console.error("Failed to get user data:", error);
          // Não navega aqui - apenas define user como null se falhar
          setUser(null);
        }
      } else {
        setUser(null);
      }
      setLoading(false);
    };
    
    initAuth();
  }, []); 

  function getToken() {
    const cookieValue = document.cookie
      .split(';')
      .find((row) => row.trim().startsWith('token='))
      ?.split('=')[1];
    return cookieValue;
  }

  function setToken(tk) {
    let now = new Date();
    const time = now.getTime();
    const expireTime = time + 1000 * 60 * 30 * 48;
    now.setTime(expireTime);
    document.cookie = `token=${tk}; expires=${now.toUTCString()}; path=/; SameSite=Strict`;
    api.defaults.headers.common['Authorization'] = tk;
  }

  function deleteCookies() {
    var allCookies = document.cookie.split(';');

    // The "expire" attribute of every cookie is
    // Set to "Thu, 01 Jan 1970 00:00:00 GMT"
    for (var i = 0; i < allCookies.length; i++)
      document.cookie = allCookies[i] + '=;expires=' + new Date(0).toUTCString();
  }

  function validateToken() {
    if (getToken() == undefined || getToken() == "") {
      setUser(null);
      return false;
    }
    setToken(getToken());
    return true;
  }

  async function getUser() {
    try {
      const res = await api.get('/auth/me/');
      setUser(res.data.username);
      setName(res.data.name);
      setPerm(res.data.permissions);
      return res.data;
    } catch (err) {
      deleteCookies();
      setUser(null);
      throw err;
    }
  }

  const checkPerm = (p) => perms.filter((perm) => perm.description === p);
  const hasPerm = (p) => checkPerm(p).length > 0;

  const signin = async (cred, callback, clerr) => {
    try {
      const res = await api.post('/auth/token/', cred);
      setUser(res.data.username);
      const token = `Bearer ${res.data.access_token}`;
      setToken(token);
      await getUser();
      if (callback) callback();
      return true;
    } catch (err) {
      if (clerr) clerr(err);
      return false;
    }
  };

  const signout = (callback = () => {}) => {
    setUser(null);
    setName(null);
    setPerm([]);
    deleteCookies();
    navigate('/login');
    callback();
  };

  let value = { 
    user,
    name, 
    validateToken, 
    signin, 
    signout, 
    hasPerm, 
    getToken, 
    perms,
    loading 
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function RequireAuth({ children }) {
  let auth = useAuth();
  let location = useLocation();

  if (auth.loading) {
    return null; // ou loading indicator, etc... (mantendo como o original)
  }

  if (!auth.user) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}

export function useAuth() {
  return React.useContext(AuthContext);
}

export function AuthStatus() {
  let auth = useAuth();
  let navigate = useNavigate();

  if (!auth.user) {
    return <p>You are not logged in.</p>;
  }

  return (
    <p>
      Welcome {auth.user}!{' '}
      <button
        onClick={() => {
          auth.signout(() => navigate('/'));
        }}
      >
        Sign out
      </button>
    </p>
  );
}